import {Button, ButtonProps} from '@mantine/core';
import {AiOutlineStop} from 'react-icons/ai';

import {useCancelExecutionMutation} from '../hooks/useExecutionsQuery.ts';
import {Execution, ExecutionStatus} from '../types.ts';

const CANCELLABLE_STATUSES: ExecutionStatus[] = [
    ExecutionStatus.PENDING,
    ExecutionStatus.RUNNING,
];

interface CancelExecutionButtonProps extends ButtonProps {
    execution: Execution;
}

export const CancelExecutionButton = ({
                                          execution,
                                          ...buttonProps
                                      }: CancelExecutionButtonProps) => {

    const cancelMutation = useCancelExecutionMutation();

    const disabled = !execution.executionStatus
        || !CANCELLABLE_STATUSES.includes(execution.executionStatus);

    const handleCancel = () => {
        const label = execution.name ?? execution.id;
        const confirmed = window.confirm(
            `Cancel execution "${label}"? Any in-flight Step Functions tasks will be stopped.`,
        );
        if (!confirmed) return;

        const reason = window.prompt('Reason for cancellation (optional):') ?? undefined;

        cancelMutation.mutate({
            id: execution.id,
            reason: reason?.trim() ? reason.trim() : undefined,
        });
    };

    return (
        <Button
            color={'red'}
            variant={'outline'}
            disabled={disabled}
            loading={cancelMutation.isPending}
            leftSection={<AiOutlineStop/>}
            onClick={handleCancel}
            {...buttonProps}
        >
            Cancel Execution
        </Button>
    );
};
